import * as React from 'react';
import Grid from '@mui/material/Grid';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

export default function SimpleBackdrop(props) {

  const {operationMessage, title, subTitle} = props;

  return (
    <div>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1,  backgroundColor: 'rgba(0, 0, 0, 0.8)'}}
        open={props.open}
        onClick={props.handleClose}
      >
        <Grid container spacing={0} direction="column"  alignItems="center"  justifyContent="center"  style={{ minHeight: '100vh' }}>
          <Grid item xs={12} sm={12} md={12}>
            <CircularProgress color="inherit" />
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            {operationMessage && <h4 style={{fontSize: '22px',fontWeight: '300'}}>{operationMessage}</h4>}
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            {title && <h3 style={{fontSize: '34px'}}>{title}</h3>}
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            {subTitle && <h4 style={{fontSize: '20px',fontWeight: '300px'}}><i>{subTitle}</i></h4>}
          </Grid>
        </Grid>
      </Backdrop>
    </div>
  );
    }